const Description = ({ children }) => {
	return (
		<div className="mt-8 leading-loose">
			{ children }
		</div>
	);
}
 
export default Description;